import { getDateFormatted } from '@vindr/utils/helpers/common.helper';
import { Row } from 'antd';
import classnames from 'classnames';
import dayjs from 'dayjs';
import DateRangePicker, {
  DateRangePickerProps,
} from '../../../ui/DateRangePicker';

interface DateRange extends DateRangePickerProps {
  title: string | boolean;
  allowClear?: DateRangePickerProps['allowClear'];
  formatDate?: DateRangePickerProps['format'];
  from: DateRangePickerProps['value'][0] | string;
  to: DateRangePickerProps['value'][1] | string;
  onChange: DateRangePickerProps['onChange'];
  wrapperClassName?: string;
}

const DateRange = ({
  formatDate,
  from,
  to,
  onChange,
  allowClear = false,
  title,
  wrapperClassName,
  ...props
}: DateRange) => {
  from = from || dayjs('19750430', 'YYYYMMDD');
  to = to || dayjs();

  return (
    <div className={classnames('filter-items', wrapperClassName)}>
      {title && <Row className="filter-title pb-1 pt-[6px]">{title}</Row>}
      <DateRangePicker
        value={[dayjs(from), dayjs(to)]}
        onChange={(values) => {
          return onChange([
            dayjs(values[0]).startOf('days').toISOString(),
            dayjs(values[1]).endOf('days').toISOString(),
          ]);
        }}
        format={formatDate || getDateFormatted()}
        allowClear={allowClear}
        {...props}
      />
    </div>
  );
};

export default DateRange;
